import type { DataCurationUIState } from '@packages/types';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: DataCurationUIState = {
    documentFilters: {
        search: undefined,
        documentType: undefined,
        dateRange: undefined,
    },
};

const dataCurationSlice = createSlice({
    name: 'dataCuration/ui',
    initialState,
    reducers: {
        setDocumentFilters(state, { payload }: PayloadAction<DataCurationUIState['documentFilters']>) {
            state.documentFilters = payload;
        },
        setSearch(state, { payload }: PayloadAction<string>) {
            state.documentFilters.search = payload;
        },
        setDocumentType(state, { payload }: PayloadAction<string[]>) {
            state.documentFilters.documentType = payload;
        },
        setDateRange(state, { payload }: PayloadAction<[string, string]>) {
            state.documentFilters.dateRange = payload;
        },
    },
});

export const { setDocumentFilters, setSearch, setDocumentType, setDateRange } = dataCurationSlice.actions;
export default dataCurationSlice.reducer;
